import { Component } from '@angular/core';

@Component({
  selector: 'nida-web-footer',
  template: ` <footer><ng-content></ng-content></footer> `,
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {}
